import * as React from 'react';

import { ECompletionYearType, FDealType, FOfferType, getRangeValue, NonEmptyArray } from '../../../../../JsonQuery';
import { getCompletionYearTypes } from '../../../../../JsonQuery/getCompletionYearTypes';
import { ConstructionYear } from '../../../components/advancedFilters/ConstructionYear';
import { AVAILABLE_COMPLETION_YEAR_TYPES } from '../../../constants/availableCompletionYearTypes';
import { useContext } from '../../../utils/useContext';
import { useDealType } from '../../../utils/useDealType';
import { useOfferType } from '../../../utils/useOfferType';

const CURRENT_YEAR = new Date().getFullYear();

export const ConstructionYearContainer: React.FC = () => {
  const { jsonQuery, onChange, isMixedFiltersRedesign } = useContext();

  const dealType = useDealType();
  const offerType = useOfferType();

  const newbuildingCompetitionYear = getCompletionYearTypes(jsonQuery, {
    yearOffset: CURRENT_YEAR,
    availableYearTypes: AVAILABLE_COMPLETION_YEAR_TYPES,
  });

  const constructionYear = getRangeValue('house_year')(jsonQuery);

  const handleConstructionYearMinChange = React.useCallback(
    (gte: number | null) => {
      onChange({ action: 'setConstructionYearMin', arguments: [gte] });
    },
    [onChange],
  );

  const handleConstructionYearMaxChange = React.useCallback(
    (lte: number | null) => {
      onChange({ action: 'setConstructionYearMax', arguments: [lte] });
    },
    [onChange],
  );

  const handleCompletionYearChange = React.useCallback(
    (completionYearTypes: NonEmptyArray<ECompletionYearType> | null) => {
      onChange({
        action: 'setCompletionYearTypes',
        arguments: [
          {
            completionYearTypes,
            yearOffset: CURRENT_YEAR,
            availableYearTypes: AVAILABLE_COMPLETION_YEAR_TYPES,
          },
        ],
      });
    },
    [onChange],
  );

  return (
    <ConstructionYear
      yearOffset={CURRENT_YEAR}
      constructionYear={constructionYear}
      newbuildingCompletionYear={newbuildingCompetitionYear}
      mixed={isMixedFiltersRedesign && dealType === FDealType.Sale && offerType === FOfferType.Flat}
      onConstructionYearMinChange={handleConstructionYearMinChange}
      onConstructionYearMaxChange={handleConstructionYearMaxChange}
      onCompletionYearChange={handleCompletionYearChange}
    />
  );
};
